module.exports = __webpack_public_path__ + "static/sms_latam-cd1b76ab5eeedec66b8a8759713d9a3c.png";